
import './index.css'
import './nes.min.css'
import 'vue2-animate/dist/vue2-animate.min.css'
import 'primevue/resources/themes/tailwind-light/theme.css'       //theme
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeicons/primeicons.css'

import PrimeVue from 'primevue/config'
import Timeline from 'primevue/timeline'
import { createApp } from 'vue'
import VueMeta from 'vue-meta'
import VueClickAway from "vue3-click-away"
import VueClipboard from 'vue3-clipboard'

import { FontAwesomeIcon } from "@/plugins/font-awesome"

import App from './App.vue'
import router from './router'

const app = createApp(App)
    
app.use(router)
    .use(PrimeVue)    
    .use(VueClickAway)
    .use(VueClipboard, {
        autoSetContainer: true,
        appendToBody: true,
      })
      .use(VueMeta, {
        refreshOnceOnNavigation: true,
      })
    .component("fa", FontAwesomeIcon)
    .component('Timeline', Timeline)
    .mount('#app')
